import request from "@js/web/request/Axios";

// 获取游戏信息
export function getGameInfo(
  data: pro.yunpb.IGameInfoReq
): Promise<pro.yunpb.IGameInfoRes> {
  return request({
    reqDesction: "GameInfoReq",
    resDesction: "GameInfoRes",
    funcName: "GetGameInfo",
    serverName: "chikii.web.WebExtObj",
    data,
    showNotification: false,
  });
}

//获取购买和充值页面
export function apiBuyAndRechargeList(
  data: pro.yunpb.IBuyAndRechargeListReq
): Promise<pro.yunpb.IBuyAndRechargeListRes> {
  return request({
    reqDesction: "BuyAndRechargeListReq",
    resDesction: "BuyAndRechargeListRes",
    funcName: "BuyAndRechargeList",
    serverName: "chikii.store.StoreExtObj",
    data,
    useSocket: true,
    showNotification: false,
  });
}

//获取已购买游戏
export function apiPurchasedGames(
  data: pro.yunpb.IPurchasedGamesReq
): Promise<pro.yunpb.IPurchasedGamesRes> {
  return request({
    reqDesction: "PurchasedGamesReq",
    resDesction: "PurchasedGamesRes",
    funcName: "PurchasedGames",
    serverName: "chikii.web.WebExtObj",
    data,
    showNotification: false,
  });
}
//获取已购买游戏详情
export function apiPurchasedGameDetail(
  data: pro.yunpb.IPurchasedGameDetailReq
): Promise<pro.yunpb.IPurchasedGameDetailRes> {
  return request({
    reqDesction: "PurchasedGameDetailReq",
    resDesction: "PurchasedGameDetailRes",
    funcName: "PurchasedGameDetail",
    serverName: "chikii.web.WebExtObj",
    data,
    showNotification: false,
  });
}

//获取已购买游戏
export function apiGetGameQAList(
  data: pro.yunpb.IGetGameQAListReq
): Promise<pro.yunpb.IGetQAListResp> {
  return request({
    reqDesction: "GetGameQAListReq",
    resDesction: "GetQAListResp",
    funcName: "GetGameQAList",
    serverName: "chikii.web.WebExtObj",
    data,
    showNotification: false,
  });
}

//获取已购买游戏问题详情
export function apiGetGameQADetail(
  data: pro.yunpb.IGetGameQADetailReq
): Promise<pro.yunpb.IGetGameQADetailResp> {
  return request({
    reqDesction: "GetGameQADetailReq",
    resDesction: "GetGameQADetailResp",
    funcName: "GetGameQADetail",
    serverName: "chikii.web.WebExtObj",
    data,
    showNotification: false,
  });
}

//web端获取通知弹窗
export function apiGetWebPopupNoticeConfig(
  data: pro.yunpb.IGetWebPopupNoticeConfigReq
): Promise<pro.yunpb.IGetWebPopupNoticeConfigRes> {
  return request({
    reqDesction: "GetWebPopupNoticeConfigReq",
    resDesction: "GetWebPopupNoticeConfigRes",
    funcName: "GetWebPopupNoticeConfig",
    serverName: "chikii.web.WebExtObj",
    data,
    showNotification: false,
  });
}
